import { motion } from 'framer-motion';

const ReviewsSection = () => {
  const reviews = [
    {
      name: 'Sarah Mitchell',
      location: 'Ilkley',
      text: 'Absolutely brilliant service! Called them out for an emergency leak and they were here within the hour. Professional, tidy, and reasonably priced.',
      rating: 5,
    },
    {
      name: 'James Thompson',
      location: 'Otley',
      text: 'Had a new boiler installed last month. The team were fantastic - arrived on time, completed the work efficiently, and left everything spotless.',
      rating: 5,
    },
    {
      name: 'Emma Roberts',
      location: 'Menston',
      text: 'Highly recommend! Fixed our central heating issue quickly and explained everything clearly. Will definitely use them again.',
      rating: 5,
    },
    {
      name: 'David Brown',
      location: 'Pool',
      text: 'Excellent workmanship and very reliable. They\'ve been maintaining our heating system for years and we wouldn\'t use anyone else.',
      rating: 5,
    },
    {
      name: 'Lisa Anderson',
      location: 'Burley in Wharfedale',
      text: 'Called for a bathroom installation quote and was impressed by their professionalism. Work completed to a high standard.',
      rating: 5,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-2 mb-4">
            <i className="ri-star-fill text-[#1A2F4A]"></i>
            <p className="text-sm uppercase tracking-wider text-[#1A2F4A] font-semibold">
              CUSTOMER REVIEWS
            </p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2F4A]">
            What Our Customers Say
          </h2>
        </motion.div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-3xl p-8"
            >
              {/* Stars */}
              <div className="flex space-x-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500"></i>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 leading-relaxed mb-6 text-sm">
                "{review.text}"
              </p>

              {/* Customer Info */}
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A2F4A] rounded-full text-white font-semibold">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-[#1A2F4A]">{review.name}</p>
                  <p className="text-sm text-gray-600">{review.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;